import { navigationStates } from '../../enums/navigationStates.js';
import { api as navigatorApi } from '../AppTopbar/navigatorActions.js';
import { api as overviewTabApi } from './overviewTabActions';
import { api as attachmentGridApi} from '../AssetPage/attachmentTabGridActions';
import {getEnumValue, enumTypes, getEnumLabel} from '../../utils/enumHelper';
import * as lotsService from '../../services/Lots/lotsService';
import Network from 'infrastructure/js/modules/network';
import {api as messageDialogApi} from '../MessageDialog/messageDialogActions';
import * as dialogHelper from 'infrastructure/js/components/Dialog/dialogHelper';
import {isLotAccessible} from '../../utils/assetHelper';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  LOT_PAGE_FETCHDATA_FINISHED: 'LOT_PAGE_FETCHDATA_FINISHED',
  LOT_PAGE_CLEAR_DATA: 'LOT_PAGE_CLEAR_DATA',
  LOT_PAGE_UNMOUNT: 'LOT_PAGE_UNMOUNT',
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  fetchDataFinished: function (payload) {
    return { type: actionTypes.LOT_PAGE_FETCHDATA_FINISHED, payload: payload };
  },
  clearData: function (payload) {
    return { type: actionTypes.LOT_PAGE_CLEAR_DATA, payload: payload };
  },
  unmount: function () {
    return { type: actionTypes.LOT_PAGE_UNMOUNT };
  },
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.init = function (lotId) {
  return function (dispatch, getState) {
    api.fetchData(dispatch, getState)(lotId, true);
  };
};

jsxActions.unmount = function() {
  return function(dispatch, getState) {
    dispatch(actions.unmount());
  }
};

jsxActions.updateLot = function (lotId, lotUpdateData) {
  return function (dispatch, getState) {
    api.updateLot(dispatch, getState)(lotId, lotUpdateData)
  };
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.fetchData = function (dispatch, getState) {
  return function (lotId, isNewLot = false) {

    navigatorApi.setLoading(isNewLot)(dispatch, getState);

    const overviewTabPromise = overviewTabApi.init(dispatch, getState)(lotId);
    const attachmentGridPromise = attachmentGridApi.reload(dispatch, getState)();

    Promise.all([overviewTabPromise, attachmentGridPromise])
      .then((allResults) => {
        const lotData = allResults[0];
        lotData.objectType = getEnumValue(enumTypes.OBJECT_TYPE)('LOT')
        let topNavigatorData = _createNavigatorData(lotData);
        navigatorApi.setData(dispatch, getState)(topNavigatorData);

        dispatch(actions.fetchDataFinished(lotData));
        navigatorApi.setLoading(false)(dispatch, getState);
      })
      .catch((err) => {
        navigatorApi.setLoading(false)(dispatch, getState);
        console.error('Fetch shift types data failed.', err);
      });
  };
};

api.updateLot = function (dispatch, getState) {
  return function (lotId, lotUpdateData) {

    navigatorApi.setLoading(true)(dispatch, getState);

    lotUpdateData.ignoreValidationWarnings = false;  //Note: handle warning/error validation witout dialog

    lotsService.updateLotStatus(lotId, lotUpdateData).then((response) => {

      navigatorApi.setLoading(false)(dispatch, getState);

      let validations = dialogHelper.getResponseValidationDetails(response);
      if (validations) {
        let val = dialogHelper.getValidationArea(validations);

        if(response.applicationResponseStatus.statusType === 'WARNING') {
          let confirmationCallback = lotsService.updateLotStatus;
          let confirmationCallbackData = {...lotUpdateData, ignoreValidationWarnings: true};

          let confirmationConfig = {
            title: val?.[0]?.title,
            message: val?.[0]?.messages?.[0]?.message ?? '',
            cancelHandler: messageDialogApi.close(dispatch, getState),
            submitButtonLabel: 'OK',
            submitHandler: () => api.handleConfirmation(dispatch, getState)(confirmationCallback, confirmationCallbackData, lotId)
          }
          messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig)
        }
        else if (response.applicationResponseStatus.statusType === 'VALIDATION_ERROR') {

          let errorConfig = {
            title: val?.[0]?.title,
            message: val?.[0]?.messages?.[0]?.message ?? '',
            type: 'error',
          }
          messageDialogApi.showMessage(dispatch, getState)(errorConfig);

          api.fetchData(dispatch, getState)(lotId);
        }
        return {success: false};
      }


      if (!Network.isResponseValid(response)) {
        messageDialogApi.responseError(dispatch, getState)(response);
        console.error('Update Lot Failed', response);
      }

      // Update Lot page to reload everything.
      api.fetchData(dispatch, getState)(lotId);
    });
  }
}

api.handleConfirmation = function(dispatch, getState) {
  return function (confirmationCallback, confirmationCallbackData, lotId) {
    messageDialogApi.close(dispatch, getState)();

    navigatorApi.setLoading(true)(dispatch, getState);

    confirmationCallbackData.ignoreValidationWarnings = true;

    confirmationCallback?.(lotId, confirmationCallbackData).then((response) => {

      navigatorApi.setLoading(false)(dispatch, getState);

      if (!Network.isResponseValid(response)) {
        messageDialogApi.responseError(dispatch, getState)(response);
        console.error('Update Lot Failed', response);
      }

      // Update Lot page to reload everything.
      api.fetchData(dispatch, getState)(lotId);
    })
  }
}

/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS
function _createNavigatorData(lotData) {
  return {
    id: lotData.id,
    name: lotData.name,
    type: navigationStates.LOT,
    // status: _getStatus(lotData),
  }
}

function _getStatus(lot) {
  return !isLotAccessible(lot?.status) ? getEnumLabel(enumTypes.LOT_STATUS)(lot?.status) : '';
}
